import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_ENDPOINTS } from "../config/api";
import "../styles/Festival.css";

const Festival = () => {

  /* ================= STATE ================= */

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  /* ================= FETCH ================= */

  useEffect(() => {
    const fetchFestivals = async () => {
      try {
        const res = await axios.get(
          API_ENDPOINTS.FESTIVALS
        );

        setData(res.data);
        setLoading(false);

      } catch (err) {
        console.log("Error fetching festivals:", err);
        setError("Failed to load festivals");
        setLoading(false);
      }
    };

    fetchFestivals();
  }, []);

  /* ================= LOADING ================= */

  if (loading) {
    return (
      <div className="festival-container">
        <p>Loading Festivals...</p>
      </div>
    );
  }

  /* ================= ERROR ================= */

  if (error) {
    return (
      <div className="festival-container">
        <p>{error}</p>
      </div>
    );
  }

  /* ================= EMPTY DATA ================= */

  if (!data) {
    return (
      <div className="festival-container">
        <p>No festival data available</p>
      </div>
    );
  }

  /* ================= UI ================= */

  return (
    <div className="festival-container">

      {/* HEADER */}
      <div className="festival-header">
        <h1>{data.headerTitle || "Festival"}</h1>
        <p>{data.headerDesc || ""}</p>
      </div>

      {/* CARDS */}
      <div className="festival-wrapper">

        {data.festivals?.length > 0 ? (
          data.festivals.map((item, index) => (
            <div className="festival-card" key={index}>

              {/* IMAGE */}
              <div className="festival-img">
                <img
                  src={
                    item.image
                      ? (item.image.startsWith("http") || item.image.startsWith("data:")
                          ? item.image
                          : `${API_ENDPOINTS.BASE_URL}${item.image.startsWith("/") ? "" : "/"}${item.image}`)
                      : "/images/placeholder.jpg"
                  }
                  alt={item.title || "Festival"}
                  onError={(e) => {
                    const baseName = item.image?.split("-").pop() || item.image?.split("/").pop();
                    if (baseName && !e.target.src.includes(`/images/${baseName}`)) {
                      e.target.src = `/images/${baseName}`;
                    } else {
                      e.target.src = "/images/placeholder.jpg";
                    }
                  }}
                />
              </div>

              {/* TITLE */}
              <h2 className="festival-title">
                {item.title || ""}
              </h2>

              {/* DESCRIPTION */}
              <p className="festival-desc">
                {item.description || ""}
              </p>

              {/* HIGHLIGHTS */}
              {item.highlights?.length > 0 && (
                <div className="festival-box">
                  <h4>✨ Highlights</h4>
                  <ul>
                    {item.highlights.map((h, i) => (
                      <li key={i}>{h}</li>
                    ))}
                  </ul>
                </div>
              )}

              {/* RITUALS */}
              {item.rituals?.length > 0 && (
                <div className="festival-box">
                  <h4>🪔 Rituals</h4>
                  <ul>
                    {item.rituals.map((r, i) => (
                      <li key={i}>{r}</li>
                    ))}
                  </ul>
                </div>
              )}

            </div>
          ))
        ) : (
          <p>No festivals found</p>
        )}

      </div>

    </div>
  );
};

export default Festival;